import React, { useEffect, useState } from 'react';
import { toast } from "react-toastify";
import _ from 'lodash';
import { QuotesGrid, ServiceThreadSpinner } from '.';
import { api, constants, helpers } from '../utils';

export default function SalesQuotes(props) {
  const [salesId, setSalesId] = useState(props.salesId);
  const [data, setData] = useState();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (props.salesId !== salesId) {
      setSalesId(props.salesId);
      setLoaded(false);
    }

    if (!loaded) {
      loadData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaded, props.salesId]);

  function exportXlsx() {
    var slsperson = (_.isNil(salesId) || salesId.length < 1) ? "x" : salesId;
    api
      .postGetBlob(`Order/ExportSalesQuotes/${slsperson}`, null)
      .then(r => {
        if (r.data.success === false) {
          if (_.isString(r.data.message)) {
            toast.error(r.data.message);
          }
          return;
        }
        if (r.data) {
          const XLSX_FILENAME = (slsperson === "x") ? "Quotes.xlsx" : `${slsperson}_Quotes.xlsx`
          helpers.downloadExport(r.data, XLSX_FILENAME, constants.MIME_TYPES.xlsx)
        } else {
          toast.error(r.message || "Error downloading report");
        }
      })
      .catch(api.catchHandler);
  }

  function loadData() {
    var slsperson = (_.isNil(salesId) || salesId.length < 1) ? "x" : salesId;
    api
      .post(`Order/GetSalesQuotes/${slsperson}`)
      .then(response => {
        if (response.data.success) {
          setData(response.data.quotes);
        }
        setLoaded(true);
      })
      .catch(api.catchHandler)
  }

  return (
    <>
      <div>
        <span className="h2 me-2">Sales Quotes</span> <span className="text-muted">Salesperson: {salesId}</span>
      </div>
      <hr />
      <ServiceThreadSpinner on={!loaded}>
        {data && data.length
          ? (<QuotesGrid
              data={data}
              exportXlsxCallback={exportXlsx}
              fromSales={true}
            />)
          : (<span className="h5">No Quotes found</span>)
        }
      </ServiceThreadSpinner>
    </>
  )
}
